import { DashboardWidgetType, DashboardWidgetUnion } from '../types';
import { createDashboardWidget } from './createDashboardWidget';

/**
 * Takes some selected widgets and generates a reasonable dashboard
 *
 * Currently (23/05/24) we are requiring the user to have the profile selector and calendar schedule
 * */
export const createTabletDashboardFromSelectedWidgets = (
  widgets?: DashboardWidgetType[]
): DashboardWidgetUnion[] => {
  if (!widgets?.length) {
    return createDefaultWidgets();
  }

  if (widgets.length === 1) {
    return [
      ...createDefaultWidgets(),
      createDashboardWidget({
        type: widgets[0],
        positions: {
          landscape: {
            height: 12,
            width: 6,
            top: 0,
            left: 6,
          },
        },
      }),
    ];
  }

  if (widgets.length === 2) {
    return [
      ...createDefaultWidgets(),
      createDashboardWidget({
        type: widgets[0],
        positions: {
          landscape: {
            height: 6,
            width: 6,
            top: 0,
            left: 6,
          },
        },
      }),
      createDashboardWidget({
        type: widgets[1],
        positions: {
          landscape: {
            height: 6,
            width: 6,
            top: 6,
            left: 6,
          },
        },
      }),
    ];
  }

  if (widgets.length === 3) {
    return [
      ...createDefaultWidgets(),

      /** Right Column */

      /** Top Left */
      createDashboardWidget({
        type: widgets[0],
        positions: {
          landscape: {
            height: 6,
            width: 3,
            top: 0,
            left: 6,
          },
        },
      }),

      /** Top Right */
      createDashboardWidget({
        type: widgets[1],
        positions: {
          landscape: {
            height: 6,
            width: 3,
            top: 0,
            left: 9,
          },
        },
      }),

      /** Bottom */
      createDashboardWidget({
        type: widgets[2],
        positions: {
          landscape: {
            height: 6,
            width: 6,
            top: 6,
            left: 6,
          },
        },
      }),
    ];
  }

  if (widgets.length === 4) {
    return [
      ...createDefaultWidgets(),
      /** Top Center */
      createDashboardWidget({
        type: widgets[0],
        positions: {
          landscape: {
            height: 6,
            width: 3,
            top: 0,
            left: 6,
          },
        },
      }),
      /** Top Right */
      createDashboardWidget({
        type: widgets[1],
        positions: {
          landscape: {
            height: 6,
            width: 3,
            top: 0,
            left: 9,
          },
        },
      }),
      /** Bottom center */
      createDashboardWidget({
        type: widgets[2],
        positions: {
          landscape: {
            height: 6,
            width: 3,
            top: 6,
            left: 6,
          },
        },
      }),
      /** Bottom right */
      createDashboardWidget({
        type: widgets[3],
        positions: {
          landscape: {
            height: 6,
            width: 3,
            top: 6,
            left: 9,
          },
        },
      }),
    ];
  }

  return [];
};

const createDefaultWidgets = () => [
  createDashboardWidget({
    type: DashboardWidgetType.PROFILE,
    positions: {
      landscape: {
        height: 2,
        width: 6,
        top: 0,
        left: 0,
      },
    },
  }),
  createDashboardWidget({
    type: DashboardWidgetType.TODAY_SCHEDULE,
    positions: {
      landscape: {
        height: 10,
        width: 6,
        top: 2,
        left: 0,
      },
    },
  }),
];

// const createCondensedDefaultWidgets = () => [
//   createDashboardWidget({
//     type: DashboardWidgetType.PROFILE,
//     positions: {
//       landscape: PROFILE_WIDGET_POSITION_CONDENSED,
//     },
//   }),
//   createDashboardWidget({
//     type: DashboardWidgetType.TODAY_SCHEDULE,
//     positions: {
//       landscape: LARGE_SCHEDULE_WIDGET_POSITION_CONDENSED,
//     },
//   }),
//   createDashboardWidget({
//     type: DashboardWidgetType.CONTACTS,
//     positions: {
//       landscape: LARGE_CONTACTS_WIDGET_POSITION_CONDENSED,
//     },
//   }),
// ];

// const PROFILE_WIDGET_POSITION_CONDENSED: DashboardWidgetPosition = {
//   height: 2,
//   width: 4,
//   top: 0,
//   left: 0,
// };

// const LARGE_SCHEDULE_WIDGET_POSITION_CONDENSED: DashboardWidgetPosition = {
//   height: 8,
//   width: 4,
//   top: 4,
//   left: 0,
// };

// const LARGE_CONTACTS_WIDGET_POSITION_CONDENSED: DashboardWidgetPosition = {
//   height: 2,
//   width: 4,
//   top: 2,
//   left: 0,
// };
